<template>
  <b-modal
    :id="modalId"
    :title="$t('createWhiteboardModalTitle')"
    hide-footer
    size="md"
    centered
    @show="onInit"
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group>
        <template v-slot:label>
          <span class="font-weight-medium text-dark">{{ $t('whiteboardNameLabel') }} <span class="text-danger">(*)</span></span>
        </template>
        <b-form-input
          id="input-wb-name"
          v-model="name"
          type="text"
          required
          minlength="1"
          maxlength="255"
          :placeholder="$t('whiteboardNamePlaceholder')"
          class="gm-input"
        />
      </b-form-group>

      <div v-if="errorMsg" class="text-danger small mb-3">
        {{ errorMsg }}
      </div>

      <div class="d-flex align-items-center justify-content-end mt-4" style="gap: 12px;">
        <b-button
          variant="secondary"
          class="px-4 py-2"
          @click="onClickCancel"
          :disabled="isSubmitting"
        >
          {{ $t('cancel') }}
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="px-4 py-2"
          :disabled="isSubmitting || !name || !name.trim()"
        >
          <b-spinner v-if="isSubmitting" small class="mr-1"></b-spinner>
          {{ $t('create') }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<style lang="scss" scoped>
.gm-input {
  border: 1px solid #cce3ff !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  background-color: #ffffff !important;
  color: #212529 !important;
  font-size: 15.5px !important;
  height: auto !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;

  &:focus {
    border-color: #0E72ED !important;
    box-shadow: 0 0 0 2px rgba(14, 114, 237, 0.2) !important;
    outline: none !important;
  }
}
</style>

<script lang="ts">
import { Component, Emit, Prop } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as whiteboardService from "@/service/whiteboardService";

@Component
export default class CreateWhiteboardModal extends BaseComponent {
  @Prop({ required: true }) modalId!: string;

  name = "";
  errorMsg = "";
  isSubmitting = false;

  @Emit("created")
  emitCreated(newWb: any) {
    return newWb;
  }

  onInit() {
    this.name = "";
    this.errorMsg = "";
    this.isSubmitting = false;
  }

  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }

  async submitForm() {
    this.name = this.name.trim();
    if (!this.name) return;
    try {
      this.isSubmitting = true;
      this.errorMsg = "";
      const response = await whiteboardService.createWhiteboard(this.name);
      const newWb = response.data?.data || response.data || response;
      if (newWb) {
        this.$bvModal.hide(this.modalId);
        this.emitCreated(newWb);
        this.toastSuccessDelay(this.$t("createSuccessful").toString());
      }
    } catch (e) {
      this.errorMsg = this.returnErrorMessage(e);
    } finally {
      this.isSubmitting = false;
    }
  }
}
</script>
